import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-rule-priorities-help',
    templateUrl: './rule-priorities-help.component.html'
})
export class RulePrioritiesHelpComponent {
}
